//* ------------------------------------*\
//    $CLASS NAMES - for class names
//      not CSS selectors
//* ------------------------------------*/

const CLASS_NAMES = {
  ABOVE_BOTTOM: 'above-bottom',
  ABOVE_HALFWAY: 'above-halfway',
  ABOVE_VIEWPORT: 'above-viewport',
  ACTIVE: 'active',
  BELOW_BOTTOM: 'below-bottom',
  BELOW_HALFWAY: 'below-halfway',
  BELOW_VIEWPORT: 'below-viewport',
  BLINK: 'blink',
  BUTTON: 'button',
  ERROR: 'error',
  CLICK: 'click',
  CLOSED: 'closed',
  FACETWP_CLEAR_SEARCH: 'facetwp-clear-search',
  FADE: 'fade',
  FILTER_SELECTED: 'filter-selected',
  FIRST_BATCH: 'first-batch',
  FIXED: 'fixed',
  FILTERED: 'filtered',
  HIDING: 'hiding',
  HIDDEN: 'hidden',
  HOVER: 'hover',
  IN_VIEWPORT: 'in-viewport',
  LISTING_FILTERS: 'listing-filters',
  LOADING: 'loading',
  MINI: 'mini',
  MODAL_MOBILE: 'modal--mobile',
  OPEN: 'open',
  OPENED: 'opened',
  PLAYING: 'playing',
  SCROLLED: 'scrolled',
  SEARCH: 'search',
  SEARCHING: 'searching',
  SELECTED: 'selected',
  SHOW: 'show',
  SHOW_SEARCH: 'show-search',
  SUB_MENU: 'sub-menu',
  SUCCESS: 'success',
  VIDEO_EMBED: 'video__embed',
  VISUALLY_HIDDEN: 'visually-hidden'
};

export default CLASS_NAMES;
